import { appConfig } from '@pinnakl/outlook-addin';
import { bootstrapOutlookAddin } from '@pinnakl/outlook-addin/core';
import { AppComponent } from './app/app.component';

bootstrapOutlookAddin(AppComponent, appConfig);
